import React from "react";
import { If } from "../If";
import { SiLogo } from "./SiLogo";
import { SiNavigation } from "./SiNavigation";
import { inject, observer } from "mobx-react";
import { UserStore } from "../../stores/UserStore";
import { LivestreamStore } from "../../stores/LivestreamStore";
import ReactModal from "react-modal";
import { MobileMenu } from "./MobileMenu";

interface ISiHeaderProps {
  authenticated: boolean;
  logout: () => void;
  userStore?: UserStore;
  livestreamStore?: LivestreamStore;
}

interface ISiHeaderState {
  isMobileMenuOpened: boolean
}

ReactModal.setAppElement('body');

export const SiHeader = inject("userStore", "livestreamStore")(observer(class SiHeader extends React.Component<ISiHeaderProps, ISiHeaderState> {
  private userStore: UserStore;
  private livestreamStore: LivestreamStore;

  constructor(props: ISiHeaderProps) {
    super(props);

    this.state = {
      isMobileMenuOpened: false
    }

    if (!props.userStore) {
      throw new Error("userStore is not defined");
    }
    if (!props.livestreamStore) {
      throw new Error("livestreamStore is not defined");
    }

    this.userStore = props.userStore;
    this.livestreamStore = props.livestreamStore;
  }

  openMenu() {
    this.setState({ isMobileMenuOpened: true })
  }

  hideMenu() {
    this.setState({ isMobileMenuOpened: false })
  }

  render() {

    return (
      <>
        <ReactModal isOpen={this.state.isMobileMenuOpened}>
          <MobileMenu hideMenu={() => this.hideMenu()} />
        </ReactModal>

        <header className="main">
          <If predicate={this.userStore.isAuthenticated}>
            <div onClick={() => this.openMenu()} className="menu-trigger">
              <i className="material-icons cursor-pointer">menu</i>
            </div>
          </If>

          <div className="row full-height">
            <div className="column align-left vertical-align-center no-align-flex">
              <a href="#/dashboard">
                <SiLogo type="colored" />
              </a>
            </div>
            <div className="column align-left vertical-align-center no-align-flex">
              <If predicate={this.userStore.theme?.logoUrl}>
                <a href={this.userStore.user.schoolContentEnabled ? "#/myschool" : this.userStore.user.districtContentEnabled ? "#/mydistrict" : "#/dashboard"}>
                  <SiLogo type="colored" organizationLogoUrl={this.userStore.theme?.logoUrl} />
                </a>
              </If>
            </div>
            <div className="column align-right vertical-align-center">
              <SiNavigation />
            </div>
          </div>
        </header>
      </>
    );
  }
}));
